import React from 'react'

const EventCard = ({ event }) => {
   return (
      <div className="relative w-full h-auto sm:h-[367px] mx-auto mb-8 rounded-lg overflow-hidden group">
         {/* Conteneur de l'image de fond */}
         <div className="absolute inset-0 z-0">
            <img
               src={event.image}
               alt="Event"
               className="w-full h-full min-h-[200px] sm:h-[330px] object-cover transition-transform duration-500 rounded-lg group-hover:scale-105"
            />
         </div>

         {/* Contenu superposé */}
         <div className="relative sm:absolute bottom-0 left-0 right-0 z-10 p-3 text-white mt-[180px] sm:mt-0">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end bg-white rounded-xl p-4 shadow-sm
            dark:bg-dark-1 dark:shadow-xl">
               <div className="flex flex-col mb-3 sm:mb-0">
                  <h4 className="text-base font-sans text-dark-1 mb-2
                  dark:text-white">{event.title}</h4>
                  <div className="flex flex-col sm:flex-row sm:flex-wrap gap-y-2 gap-x-4 text-gray-500 dark:text-gray-400">
                     <div className="flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span className="text-sm">{event.date}</span>
                     </div>
                     <div className="flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="text-sm">{event.location}</span>
                     </div>
                  </div>
               </div>

               <button className="px-4 sm:px-6 py-2 text-sm font-medium text-purple-1 bg-white rounded-full dark:bg-dark-5 
               hover:bg-purple-1 border border-purple-1 hover:text-white transition-colors duration-300 dark:hover:bg-purple-1 w-full sm:w-auto text-center">
                  Buy
               </button>
            </div>
         </div>
      </div>
   );
}

export default EventCard;